import React from "react";
import { Field, useFormikContext } from "formik";

const FormInput = ({ name, type, fullWidth, style, ...rest }: any) => {
  const { touched, errors, setFieldValue }: any = useFormikContext();

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    let truncatedValue;

    if (type === "number") {
      // Restrict to positive integers
      const intValue = parseInt(value, 10);
      truncatedValue = isNaN(intValue) ? "" : Math.max(0, intValue);
    } else if (type === "textArea") {
      // For textArea, truncate to a certain length
      truncatedValue = value.slice(0, 500);
    } else if (type === "contact_number") {
      const digitsOnly = value.replace(/\D/g, "");
      truncatedValue = digitsOnly.slice(0, 11);
    } else if (type === "text") {
      truncatedValue = value.replace(/[^a-zA-Z\s]/g, "").slice(0, 40);
    } else if (type === "address") {
      truncatedValue = value.slice(0, 40);
    } else {
      truncatedValue = value.slice(0, 40);
    }
    setFieldValue(name, truncatedValue);
  };

  const fieldProps = {
    style: { width: fullWidth ? "100%" : undefined, ...style },
  };

  if (type === "textArea") {
    return (
      <Field
        as="textarea"
        name={name}
        type={type}
        error={errors?.[name] && touched?.[name]}
        helperText={errors?.[name]}
        {...rest}
        onChange={handleInputChange}
        {...fieldProps}
      />
    );
  }

  return (
    <Field
      name={name}
      type={type}
      error={errors?.[name] && touched?.[name]}
      helperText={errors?.[name]}
      {...rest}
      onChange={handleInputChange}
      {...fieldProps}
      inputProps={{ style: { padding: "10px 12px" } }}
    />
  );
};

export default FormInput;
